import { createSigningSession as apiCreateSigningSession } from "../../api/esignature/esignatureAPI";

/**
 * E-Signature Service
 * Handles document signing via backend API integration
 */

class ESignatureService {
  constructor() {
    // No SignWell configuration needed - all handled by backend API
  }

  /**
   * Create a new signing session for a document using your existing API
   * @param {Object} params - Signing session parameters
   * @param {string} params.documentType - Type of document to sign
   * @param {string} [params.filingUuid] - Optional filing UUID
   * @param {string|number} [params.userId] - Optional user ID
   * @returns {Promise<Object>} Signing session data with iframe HTML
   */
  async createSigningSession({ documentType, filingUuid, userId }) {
    try {
      return await apiCreateSigningSession({
        documentType: documentType.toLowerCase(), // Convert W9 to w9
        filingUuid,
        userId,
      });
    } catch (error) {
      throw error;
    }
  }
}

// Export singleton instance
export const eSignatureService = new ESignatureService();
export default eSignatureService;
